import { render, staticRenderFns } from "./ProjectEditSurfaces.vue?vue&type=template&id=01b1f1dc&"
import script from "./ProjectEditSurfaces.vue?vue&type=script&lang=js&"
export * from "./ProjectEditSurfaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports